module.exports = __webpack_public_path__ + "static/media/edit-icon.35e99398.svg";